import React, { useState } from "react";

import { LivePanel } from "@demo/ui/LivePanel.js";
import { FlightRecord } from "@demo/ui/FlightRecord.js";
import { FLIGHT_GIG_CATALOG } from "@demo/live/gig-catalog-flight.js";
import { TESSERA } from "./scenario/tessera.js";
import { FLIGHT_BUNDLES } from "./data.js";

// The Tessera app leads with an Overview — the flight record, a distinct
// ops-console layout — with the live seal behind a second tab. Everything below
// the masthead is shared UI driven by Tessera's copy; the recorded receipts the
// Overview verifies are two real eight-action flight records
// (apps/flight-demo/src/data.ts).
type Mode = "overview" | "live";

export function App() {
  const [mode, setMode] = useState<Mode>("overview");

  return (
    <div className="page">
      <div className="disclosure-banner" role="note">
        <span className="disclosure-dot" aria-hidden="true" />
        <span>{TESSERA.disclosure}</span>
      </div>

      <header className="masthead">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            {TESSERA.client.mark}
          </span>
          <div>
            <div className="brand-name">{TESSERA.client.name}</div>
            <div className="brand-domain">{TESSERA.client.domain}</div>
          </div>
        </div>
        <div className="masthead-tag">{TESSERA.masthead}</div>
      </header>

      <div className="mode-toggle" role="tablist" aria-label="Demo section">
        <button
          role="tab"
          aria-selected={mode === "overview"}
          className={"mode-toggle-btn" + (mode === "overview" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("overview")}
        >
          Overview
        </button>
        <button
          role="tab"
          aria-selected={mode === "live"}
          className={"mode-toggle-btn" + (mode === "live" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("live")}
        >
          Run live
        </button>
      </div>

      {mode === "overview" ? (
        <main className="content">
          <FlightRecord
            config={TESSERA.record}
            bundles={FLIGHT_BUNDLES}
            ctas={[{ ...TESSERA.liveCta, onClick: () => setMode("live") }]}
          />
        </main>
      ) : (
        <main className="content">
          <section className="intro">
            <h1>{TESSERA.intro.headline}</h1>
            <p>{TESSERA.intro.body}</p>
          </section>

          <LivePanel catalog={FLIGHT_GIG_CATALOG} copy={TESSERA.live} />
        </main>
      )}

      <footer className="footer">
        <p>
          {TESSERA.disclosure} Built on <span className="footer-link">{TESSERA.product.name}</span>:{" "}
          {TESSERA.product.tagline}.
        </p>
      </footer>
    </div>
  );
}
